import Vue from 'vue'
import VueLeaflet from '@vdcrea/vue-leaflet'
import '@vdcrea/vue-leaflet/dist/vue-leaflet.css'

Vue.use(VueLeaflet)
